// src/UserFormPage.js

import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Layout,
  Avatar,
  Upload,
  Switch,
  Row,
  Col,
  Breadcrumb,
  Card,
  message,
} from "antd";
import { ArrowLeftOutlined, EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { getDecryptSession } from "../../../Shared/Utils/CommonUtils";
const { Option } = Select;
const { Header, Content } = Layout;





const AddEditRole = ({ ...props }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { roleId } = useParams();
  const [userData, setUserData] = useState();
  const [defaultData,setDefaultData] = useState();
  const [userPermissions, setUserPermissions] = useState([]);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if(roleId) {
      getRoleData();
    } else {
      setLoader(false);
    }
    getUserPermissions();
    getUsers();
  }, []);

  const getRoleData = () => {
      let payload={
        roleId : Number(roleId)
      }
      ServiceUtils.postRequest('roleData', payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let roleDa= JSON.parse(JSON.stringify(response?.data?.data));
            setUserData(roleDa)
            setDefaultData(roleDa);
            setLoader(false);
          } 
          else if(response.status === 401 ){
            navigate('/logout');
          }
          else {
            alertService.error(response.data.message)
          }
        },
        (error) => {
          alertService.error('Error while fetching data')
          console.log(error)
        }
      );
    }

  const getUserRoleDetails = () => {
    let data = {
      "roleName": "Admin",
      "roleDescription": "All Configuration Management + User Management",
  }
  let parsed = JSON.parse(JSON.stringify(data))
    setUserData(parsed);
    setDefaultData(parsed);
  }

  const getUserPermissions = () => {
      let payload={
        type : "permissions"
      }
      ServiceUtils.postRequest('lookup', payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            const permissionList = response?.data?.data;
            // const permissions = [
            //   {
            //     label: 'test',
            //     value: 'abc'
            //   }
            // ]
            setUserPermissions(permissionList);
          } 
          else if(response.status === 401 ){
            navigate('/logout');
          }
          else {
            alertService.error(response.data.message)
          }
        },
        (error) => {
          alertService.error('Error while fetching data')
          console.log(error)
        }
      );
    }

    const getUsers = () => {
        let payload={};
        ServiceUtils.postRequest('surveyArcAttendees', payload).then(
          (response) => {
            if (response.status === 200 && response?.data.status) {
              const users = response?.data?.data;
              setUsers(users);
            } 
            else if(response.status === 401 ){
              navigate('/logout');
            }
            else {
              alertService.error(response.data.message)
            }
          },
          (error) => {
            alertService.error('Error while fetching data')
            console.log(error)
          }
        );
      }

  const handleInputChange = (key, value, action) => {
    if (action === "onchange") {
      setUserData({
        ...userData,
        [key]: value,
      });
    }
  };

  const SubmitButton = ({ form, children }) => {
    const [submittable, setSubmittable] = useState(false);

    const values = Form.useWatch([], form);
    useEffect(() => {
      form
        .validateFields({
          validateOnly: true,
        })
        .then(() => setSubmittable(true))
        .catch(() => setSubmittable(false));
    }, [form, values]);
    return (
      <Button type="primary" htmlType="submit" disabled={!submittable || (JSON.stringify(defaultData)===JSON.stringify(values)) } onClick={handleSave}>
        {children}
      </Button>
    );
  };

  const handleSave = (values) => {
    addEditRole();
  };


  const addEditRole = () => {
    let payload = {
        "type": roleId  ? 'edit' : 'add',
        "roleData": userData
    }
    if(roleId) {
      payload['roleData']['roleId'] = roleId;
    }
    ServiceUtils.postRequest('roleOps', payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
              navigate("/admin/settings");
          } 
          else if(response.status === 401 ){
            navigate('/logout');
          }
          else {
            alertService.error(response.data.message)
          }
        },
        (error) => {
          alertService.error('Error while fetching data')
          console.log(error)
        }
      );
  }

  return (
    <div>
      {
        !loader &&
        <div>
          <Card
            style={{ width: "100%", height: "fit-content" }}
            bodyStyle={{ padding: "10px" }}
          >
            {roleId ? (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        <div style={{ margin: "0px 2px" }}>Edit Role</div>
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        <div style={{ margin: "0px 2px" }}>Add Role</div>
                      </div>
                    ),
                  },
                ]}
              />
            )}
          </Card>
          <Content
            style={{
              padding: "24px",
              background: "#fff",
              height: "calc(100vh - 90px)",
            }}
          >
              <Form
                  form={form} 
                  initialValues={userData && userData}
                  name="validateOnly" 
                  layout="vertical" 
                  autoComplete="off"             
                >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Role Name
                    </label>
                    <Form.Item  name="roleName"
                      rules={
                        [
                          {
                            required: true,
                            message: "Role Name is required.",
                          },
                        ]
                      }
                      >
                      <Input
                        value={userData?.roleName} 
                        onChange={(e) =>
                          handleInputChange("roleName", e.target.value, "onchange")
                        
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Description
                    </label>
                    <Form.Item name="roleDescription"
                      rules={
                        [
                          {
                            required: true,
                            message: "Description is required.",
                          },
                        ]
                      }
                      >
                      <Input
                      value={userData?.roleDescription} 
                        onChange={(e) =>
                          handleInputChange("roleDescription", e.target.value, "onchange")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Permissions
                    </label>
                    <Form.Item name="permissions"
                      rules={
                        [
                          {
                            required: true,
                            message: "Permissions is required.",
                          },
                        ]
                      }
                      >
                      <Select
                        mode="multiple"
                        showSearch
                        defaultValue={userData?.permissions}
                        onChange={(e) => {
                          handleInputChange("permissions", e, "onchange");
                        }}
                        options={userPermissions}
                        allowClear
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Users
                    </label>
                    <Form.Item name="users"
                      rules={
                        [
                          {
                            required: true,
                            message: "Users is required.",
                          },
                        ]
                      }
                      >
                      <Select
                       mode="multiple"
                       showSearch
                       defaultValue={userData?.users}
                        onChange={(e) => {
                          handleInputChange("users", e, "onchange");
                        }}
                        options={users}
                        allowClear
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <div className="submit-block"  style={{ position: 'absolute',bottom: '5px', right:'5px' }}>
                <div style={{ paddingRight: "10px" }}>
                  <SubmitButton form={form} >{roleId?'Update':'Save'}</SubmitButton>
                </div>
                <Button onClick={()=>navigate("/admin/settings")}>Cancel</Button>
              </div>
          </Content>
        </div>
      }
    </div>
  );
};

export default AddEditRole;
